// extracted by mini-css-extract-plugin
export default {"tableTitleRow":"style_tableTitleRow__Uz4hL","tableTitle":"style_tableTitle__YKsV6","tableButton":"style_tableButton__f-Y4C","tableSearch":"style_tableSearch__9Qtph"};